export default "__VITE_ASSET__Bfom52pb__"